module.exports = __webpack_public_path__ + "static/media/infoIcon.2f35ec62.svg";